// extracted by mini-css-extract-plugin
module.exports = {"desktopCtasContainer":"DesktopCtas_desktopCtasContainer__4xvso","floating":"DesktopCtas_floating__5drI9"};